// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React, { createRef } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  SMSSend,
  MessageVariableChooser,
  Feedback,
  SvgIcon
} from '../../'

import { CHANNEL_SMS_MESSAGEPLUS } from '../../../constants'

const textAreaRef = createRef()

const QUERY_CHANNEL = gql`
  query($id: ID!) {
    channel(id: $id) {
      id
      outboundAddr
    }
  }
`


export class SMSMessageComposer extends React.Component {
  static propTypes = {
    fromIdentityId: PropTypes.string.isRequired,
    toIdentityId: PropTypes.string.isRequired,
    onMessageCreateSuccess: PropTypes.func,
    onMessageCreateFail: PropTypes.func,
    termSelectorLabel: PropTypes.string,
    terms: PropTypes.arrayOf(PropTypes.string),
    setTemplateContent: PropTypes.string,
    onMessageSentSuccess: PropTypes.func,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  state = {
    message: '',
    cursor: 0,
    showSendSuccess: false
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.setTemplateContent &&
      this.props.setTemplateContent.length > 0 &&
      this.state.message !== this.props.setTemplateContent) {

      this.setState({
        message: this.props.setTemplateContent
      })
    }

    if (prevProps.setTemplateContent &&
      prevProps.setTemplateContent.length > 0 &&
      this.props.setTemplateContent === null) {

      this.setState({ message: '' })
    }
  }

  injectTerm = (term) => {
    // could use drag & drop mechanism too
    const currentCaretPosition = this.getCaretPosition()

    this.setState(prevState => {
      let prevMessage = prevState.message

      return { message: prevMessage.slice(0, currentCaretPosition) + `${term}` + prevMessage.slice(currentCaretPosition) }
    })
  }

  getCaretPosition = () => {
    const textArea = document.getElementById('messageContent')
    const position = textArea.selectionStart
    return position
  }

  replaceLast(find, replace, string) {
    var lastIndex = string.lastIndexOf(find)

    if (lastIndex === -1) {
        return string
    }

    var beginString = string.substring(0, lastIndex)
    var endString = string.substring(lastIndex + find.length)

    return beginString + replace + endString
  }

  handleMessageChange = (e) => {
    let message = e.target.value

    this.setState({ message })
  }

  focusOnMessageInput = () => textAreaRef.current.focus()  // focus on SMSSend TextArea

  handleMessageChange = (message) => this.setState({ message })

  clearMessage = () => this.setState({ message: '' })

  showMessageSendSuccess = () => this.setState({ message: '', showSendSuccess: true })

  render() {
    const { fromIdentityId, toIdentityId, termSelectorLabel, terms, setTemplateContent, onMessageSentSuccess, className } = this.props

    return (
      <div className={className}>
        <div className='slds-grid'>
          <Query query={QUERY_CHANNEL} variables={{ id: CHANNEL_SMS_MESSAGEPLUS }}>
            {({ loading, error, data }) => {
              if (loading || error) {
                return null
              }

              return (
                <SMSSend
                  toIdentityId={toIdentityId}
                  fromIdentityId={fromIdentityId}
                  fromAddr={data.channel.outboundAddr}
                  // replyToMessage={message}
                  message={this.state.message}
                  channelId={CHANNEL_SMS_MESSAGEPLUS}
                  onChange={this.handleMessageChange}
                  onCancelClick={this.clearMessage}
                  onMessageCreateSuccess={() => {
                    this.showMessageSendSuccess()
                    if (onMessageSentSuccess) {
                      onMessageSentSuccess()
                    }
                  }}
                  onMessageCreateFail={null}
                  forwardedRef={textAreaRef}
                  setTemplateContent={!!setTemplateContent}
                  className='slds-large-size_5-of-12 slds-medium-size_2-of-3'
                />
              )
            }}
          </Query>
          {terms &&
            <MessageVariableChooser
              label={termSelectorLabel}
              variables={terms}
              onClick={term => {
                this.injectTerm(term)
                this.focusOnMessageInput()
              }}
              className='slds-m-left_small'
            />
          }
        </div>
        <div className='slds-grid slds-m-top_medium' style={{ alignItems: 'center' }}>
          <SvgIcon
            variant='utility'
            symbol='info'
            colour='light'
          />
          <div className='slds-text-color_weak slds-m-left_small'>
            <div>
              {`Character count: ${this.state.message.length}`}
            </div>
            <div className='slds-text-body_small'>
              NOTE: You will be billed in 160 character units.
            </div>
          </div>
        </div>
        {this.state.showSendSuccess &&
          <Feedback
            message='Sent'
            fadeDuration={2500}  // 2.5s matches .feedback-fade css class animation
            unmount={() => this.setState({ showSendSuccess: false })}
            icon={
              <SvgIcon
                variant='utility'
                symbol='check'
                colour='inverse'
                className='slds-align_absolute-center'
              />
            }
          />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/sms-message-composer/index.js